<section>
  <div class="container px-md-0">
    <div class="section-header py-5">
      <h3 class="title">{{translationScope+'.titles.course_overview' | transloco}}</h3>
      <div class="overview">{{translationScope+'.subtitles.course_overview' | transloco}}
        <a class="reference-link" [routerLink]="'/kursoversikt/informasjon/hoyhastighetsbevis'">{{translationScope+'.read_more_about_evidence_here' | transloco}}</a>
      </div>
    </div>
  </div>
</section>
<ng-container *ngIf="studentTemplates$ | async as templates">
  <section>
    <div class="container px-md-0">
      <div class="row">
        <div class="col-12 pb-2">
          <div class="course-section">
            <h4 class="course-section-title">{{translationScope+'.titles.classroom_course' | transloco}}</h4>
          </div>
        </div>
      </div>
      <div class="row global-card">
        <div class="col-12 col-sm-12 col-md-6 col-lg-3 pb-3" *ngFor="let template of templates">
          <app-course-template-card
            [template]="template">
          </app-course-template-card>
        </div>
      </div>
    </div>
  </section>
</ng-container>
<section>
  <div class="container px-md-0">
    <div class="row pt-3">
      <div class="col-12 pb-2">
        <div class="course-section">
          <h4 class="course-section-title">{{translationScope+'.titles.digital_course' | transloco}}</h4>
        </div>
      </div>
    </div>
    <div class="row global-card">
      <div *ngFor="let digitalCourse of (digitalCourses$ | async)" class=" col-12 col-sm-12 col-md-6 col-lg-3 pb-3">
          <app-digital-course-preview-card
              [course]="digitalCourse">
          </app-digital-course-preview-card>
      </div>
    </div>
  </div>
</section>

